import { useCallback, useContext, useMemo } from "react";

import SessionContext from "app/contexts/SessionContext";
import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useSelectorRetainers = () => {
    const { getDataAsync } = useApi();
    const session = useContext(SessionContext);

    const getSelectorRetainersApiCall = useCallback(async () => {
        const response = await getDataAsync("selectorRetainers", {
            urlParams: [
                { name: "$userId", value: session.id },
                { name: "$isAdmin", value: session.isLegacyAdminUser },
                { name: "$agencyId", value: session.agencyId },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync, session.id, session.isLegacyAdminUser, session.agencyId]);

    const selectorRetainers = useQuery(
        "selectorRetainersList",
        getSelectorRetainersApiCall
    );

    return useMemo(() => {
        return {
            selectorRetainers,
        };
    }, [selectorRetainers]);
};

export default useSelectorRetainers;
